import Guid from "common/values/guid/guid";

export default class CreateNetworkedGroupApiRequest {
  name?: string;
  description?: string;
  memberUserIds: Guid[] = [];

  constructor(name?: string, description?: string, memberUserIds: Guid[] = []) {
    this.name = name;
    this.description = description;
    this.memberUserIds = memberUserIds;
  }
}
